export type Role =
  | 'platform_admin'
  | 'platform_support'
  | 'tenant_admin'
  | 'sales_agent'
  | 'project_manager'
  | 'office_admin'
  | 'crew_member';

/** Human-readable labels for the built-in roles (see root CLAUDE.md → Roles). */
export const ROLE_LABELS: Record<Role, string> = {
  platform_admin: 'Platform Admin',
  platform_support: 'Platform Support',
  tenant_admin: 'Tenant Admin',
  sales_agent: 'Sales Agent',
  project_manager: 'Project Manager',
  office_admin: 'Office Admin',
  crew_member: 'Crew Member',
};

/** Display label for a role value — falls back to title-casing unknown/custom roles. */
export const roleLabel = (role: string | null | undefined): string => {
  if (!role) return '';
  return (
    ROLE_LABELS[role as Role] ??
    role.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())
  );
};

export type Permission = string;

export interface User {
  id: string;
  email: string;
  name: string;
  roles: Role[];
  permissions: Permission[];
  tenantId: string;
}

export interface SelectOption {
  label: string;
  value: string;
}
